<header class="flex items-center justify-between px-6 py-3 bg-white">
  <mai-mib-logo></mai-mib-logo>
  @if (isReady()) {
    <mib-badge theme="success" mode="word" size="large" contrast="ascent" shape="rounded-full gap-1">
      <svg mib-ai-icon class="size-3" aria-hidden="true"></svg>
      AI Active
    </mib-badge>
  }
</header>
